import {ApiService} from "../api";
import {AxiosResponse} from "axios";
import {UserDTO} from "../../types/DTOs/UserDTO";
import {Log} from "../../utils/Log";

export class UserAPI extends  ApiService{
    private constructor() {
        super();
    }

    async  getUserData(): Promise<UserDTO> {
        const response: AxiosResponse<UserDTO> = await this.api.get('/userdata');
        Log.writeLogDebug(response.data);
        return response.data;
    }

    async updateUserData(data: Partial<UserDTO>): Promise<UserDTO> {
        const response: AxiosResponse<UserDTO> = await this.api.put(`/userdata`, data);
        return response.data;
    }
}